import React from "react";

import getSitemapLocations from "api/requests/consumerApi/getSitemapLocations";
import { createGetServerSideProps } from "utils/createGetServerSideProps";

import Breadcrumb from "components/Breadcrumb";
import Breadcrumbs from "components/Breadcrumbs";
import LocationsGrid, { Locations } from "components/LocationsGrid";
import MetaTags from "components/MetaTags";

type LocationsPageProps = {
  locations: Locations;
};

const LocationsPage: React.FC<LocationsPageProps> = ({ locations }) => (
  <>
    <MetaTags
      title="Weed Dispensaries in a City Near You | Leafly"
      description="Find a list of dispensaries in a city near you using our location page. Discover, learn, and buy cannabis with Leafly."
    />

    <div className="container mt-xl mb-xxl">
      <h1 className="mb-lg">Dispensaries in a city near you</h1>

      <LocationsGrid locations={locations} className="mb-section" />

      <Breadcrumbs>
        <Breadcrumb href="/dispensaries">Dispensaries</Breadcrumb>
        <Breadcrumb currentLocation href="/dispensaries/locations">
          All locations
        </Breadcrumb>
      </Breadcrumbs>
    </div>
  </>
);

export const getServerSideProps = createGetServerSideProps<LocationsPageProps>(
  async () => {
    const locations = await getSitemapLocations();

    if (!locations) {
      return {
        redirect: { destination: "/dispensaries", permanent: false },
      };
    }

    return {
      props: {
        locations,
      },
    };
  },
);

export default LocationsPage;
